import EdDropdown from './ed-dropdown/ed-dropdown.vue';
import EdTabs from './ed-tabs/ed-tabs.vue';
import EdPopupMenuComponent from './ed-popup-menu/ed-popup-menu.component.vue';
import EdPopupMenuItemComponent from './ed-popup-menu-item/ed-popup-menu-item.component.vue';

export const NavigationComponents = {
  EdDropdown,
  EdTabs,
  EdPopupMenuComponent,
  EdPopupMenuItemComponent
}
